import './navigation';
import './header';
import './ajax-add-to-cart';
import './contact-page-tabs';
import './InteractiveMap';
import './qr-code-display';
import './single-post-aside-products-slider';


const hide__prices = document.querySelectorAll('.hide__price');

if(hide__prices){

  hide__prices.forEach((hide__price) => {
    hide__price.addEventListener('click', () => {
        window.location = "https://janser.pl/moje-konto/"; 
    });
  });

}
